module.exports = __webpack_public_path__ + "static/media/image_17.052c5b91.png";